/*
view_creditcardlast.js
create and handle selection list to be inserted in a <form>
*/

import core from '../../common/lib/core.js';
// import constants from '../../common/lib/utils/constants.js';
import actions from '../../common/lib/utils/actions.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

let textkeysObj = {};
const addNewCardAttr = 'addnewcard';
const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';

function createSelectMethod(eventFilter) {
	const cName = `${eventFilter} payment__select-lastused`;
	return create({
		type: 'select',
		class: cName
	});
}

function createOptionForAdd(text, addAttribute) {
	const elm = create({
		type: 'option',
		class: 'payment__option-lastused',
		add: 'add',
		value: addAttribute
	});
	if (text) {
		elm.innerHTML = text;
	}
	return elm;
}

function createOptions(objById) {
	const nodes = [];
	const options = {};
	if (objById) {
		Object.keys(objById).forEach((key) => {
			/* A reference to the element is saved. */
			const tempObj = {
				value: (objById[key].id || 'id missing'),
				vm: (objById[key].vm || 'vm missing'),
				vy: (objById[key].vy || 'vy missing'),
				co: (objById[key].co || 'co missing'),
				cn: (objById[key].cardNo || textkeysObj['cardnumber-missing-replacer'])
			};
			options[key] = create({
				type: 'option',
				class: 'payment__option-lastused',
				value: tempObj.value,
				vm: tempObj.vm,
				vy: tempObj.vy,
				co: tempObj.co,
				cn: tempObj.cn
			});
			if (objById[key].selected) {
				options[key].selected = true;
			}
			/* the replacement for the cardnumber is injected here, 'xxxxxxx1234' */
			options[key].innerHTML += tempObj.cn;
			/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
			nodes.push(options[key]);
		});
	} else {
		console.warn('view_creditcardlast:createOptions: can not get last details in object: missing property "by_id"', objById);
	}
	return nodes;
}

function getSelectedOption(selectElement) {
	const index = Boolean((selectElement && selectElement.options) && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	const elm = (index ? selectElement.options[selectElement.selectedIndex] : null);
	return elm;
}

function getCardValues(selectElm) {
	/* this function sometimes throws error during navigation through the depositflow and
	is therefore surrounded with extra property checks */
	let cn = null;
	let co = null;
	let cardid = null;
	let vm = null;
	let vy = null;
	let add = null;
	let elm = null;
	const selectedOption = getSelectedOption(selectElm);
	elm = selectedOption;

	if (elm && elm.getAttribute) {
		cn = (elm.getAttribute('cn') || null);
		co = (elm.getAttribute('co') || null);
		cardid = (elm.getAttribute('value') || null);
		vm = (elm.getAttribute('vm') || null);
		vy = (elm.getAttribute('vy') || null);
		add = Boolean(elm.getAttribute('add'));
	}
	return {
		vm,
		vy,
		cn,
		co,
		cardid,
		add
	};
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		onEventCb();
		const card = getCardValues(p.elm);
		actions.viewCreditcardlast(card);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

export default {
	create(p) {
		let elements = {};
		const mainEventType = 'change';
		const classNameEventFilter = 'js-eventfilter-viewcreditcardlast';
		textkeysObj = viewTextkeys.depositflow();
		elements.wrap = (elements.wrap || createSelectMethod(classNameEventFilter));
		const callbackOnMainEvent = (p.callbackonmainevent || function temp() {});
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			getValues() {
				/* return values from selected option */
				const selectElement = elements.wrap;
				const val = getCardValues(selectElement);
				return val;
			},
			update(state) {
				// const accounts = ((state.fetch_methoddetails && state.fetch_methoddetails.hasAccounts) && state.fetch_methoddetails.accounts);
				const accounts = (state.fetch_methoddetails && state.fetch_methoddetails.accounts);
				const accountById = (accounts && accounts.by_id);
				const submitWasDone = ((state && state.submit_payment) && (state.submit_payment.success || state.submit_payment.error));
				if (accounts && !elements.options) {
					elements.options = createOptions(accountById);
					elements.options.push(createOptionForAdd(textkeysObj['deposit-paymentmethods-addcard-selecttext'], addNewCardAttr));
					elements.wrap.appendChild(nodetree(elements.options));
				}
				if (submitWasDone) {
					/* the submit was done, and now the selectionlist shall be reset so
					that the user is forced to actively select an old one or type a new, and
					thereby refresh the input. */
					// selectOptionToAdd(elements.wrap, value);
					if (elements && elements.wrap) {
						elements.wrap.value = addNewCardAttr;
					}
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_creditcardlast:187');
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-creditcardlast.js